<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('recipe:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            
            <a-col :md="8" :sm="24">
                <a-form-item label="开方时间">
                  <a-date-picker style="width: 100%" placeholder="请选择开方时间"  @change="onChangectstamp"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="处方状态">
                  <!-- <a-input v-model="queryParam.status" allow-clear placeholder="请输入状态"/> -->
                  <a-select v-model="queryParam.status"  allow-clear placeholder="请选择处方状态" :options="recipeStatus"></a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="处方类型">
                  <!-- <a-input v-model="queryParam.businessType" allow-clear placeholder="请输入处方类型"/> -->
                  <a-select v-model="queryParam.category"  allow-clear placeholder="请选择处方类别" :options="category"></a-select>
                </a-form-item>
              </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="科室">
                  <a-input v-model="queryParam.deptName" allow-clear placeholder="请输入科室"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="医生姓名">
                  <a-input v-model="queryParam.drName" allow-clear placeholder="请输入医生姓名"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="医生职称">
                  <a-input v-model="queryParam.protitleName" allow-clear placeholder="请输入医生职称"/>
                </a-form-item>
              </a-col>
              
            </template>
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
        :loading="loading"
      >
        <template class="table-operator" slot="operator" >
          <x-down
            v-if="hasPerm('recipe:export')"
            ref="batchExport"
            @batchExport="batchExport"
          />
        </template>

        <span  slot="patientsex" slot-scope="text, record"> 
            {{record.patientsex == '1'? '男' : '女'  }}
        </span>
        <span slot="negotiationFlag" slot-scope="text, record">
          <a style="color:#000000A6"> {{ record.negotiationFlag == '0' ? '否' : record.negotiationFlag == '1' ? '是' : '否' }} </a>
        </span>
        <span  slot="category" slot-scope="text, record"> 
            {{record.category == '1'? '西药/中成药' : record.category == '2'? '中药处方' : '' }}
        </span>
        <span  slot="status" slot-scope="text, record">
            {{ record.status == '1' ? '医生已撤销' : record.status == '2' ? '审核驳回' : record.status == '3' ? '审核通过' : record.status == '4' ? '审核中' : record.status == '5' ? '审核超时' : record.status == '6' ? '患者已取消' : '' }}
        </span> 
        <span slot="ybUploadStatus" slot-scope="text, record">
          <a>{{ record.ybUploadStatus == '0' && record.negotiationFlag == 1 ? '未上传' : record.ybUploadStatus == '1' && record.negotiationFlag == 1 ? '上传成功' : record.uploadFlag == '2' && record.negotiationFlag == 1 ? '上传成功' :  ' ----' }}</a>
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="clickDetial(record, false)" v-if="record.status == '4' " style="margin-right:5px">审核</a>
          <!-- <a @click="handleRefuse(record)" v-if="record.status == '3' && record.isCanReject == '1' " style="margin-right:5px">审核驳回</a> -->
          
          <a @click="clickDetial(record, true)" style="margin-right:5px">查看详情</a>

          <a @click="clickUpload(record)" v-if="record.negotiationFlag == 1 && record.status == 3 && record.uploadFlag == 0 ">处方上传</a>
          <a @click="clickUpload(record)" v-else-if="record.negotiationFlag == 1 && record.status == 3 && record.uploadFlag == 1 ">处方上传</a>
          <!-- <a-divider type="vertical" v-if="hasPerm('recipe:edit') & hasPerm('recipe:delete')"/> -->
          <!-- <a-popconfirm v-if="hasPerm('recipe:delete')" placement="topRight" title="确认删除？" @confirm="() => singleDelete(record)">
            <a>删除</a> 
          </a-popconfirm> -->

        </span>
      </s-table>
      
    </a-card>
    <add-form-xi ref="addFormXi" @ok="handleOk" />
    <add-form-zhong ref="addFormZhong" @ok="handleOk" />
     <!-- 审核驳回窗口 -->
      <a-modal v-model="refuse" title="审核驳回" @cancel="handleBack">
      <template slot="footer">
        <a-button key="back" @click="handleBack">
          取消
        </a-button>
        <a-button key="cancel" @click="handleReject" :loading="failedApproved">
          审核驳回
        </a-button>
      </template>
      <a-textarea v-model="refuseReason" placeholder="请输入驳回理由" :auto-size="{ minRows: 3, maxRows: 5 }" />
    </a-modal>

  </div>

 

</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { recipePage, recipeExport, recipePreVer, recipeUpload ,recipeCancel} from '@/api/modular/interhospital/recipe/recipeManage'
  import addFormXi from './addForm.vue'
  import addFormZhong from './addFormZhong.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      editForm,
      addFormXi,
      addFormZhong,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        loading : false,
        // 查询参数
        queryParam: {},
        // 审核状态
        recipeStatus : [
          {
            value: '1',
            label: '医生已撤销',
          },
          {
            value: '6',
            label: '患者已取消',
          },
          {
            value: '2',
            label: '审核驳回',
          },
          {
            value: '3',
            label: '审核通过',
          },
          {
            value: '4',
            label: '审核中',
          },
          // {
          //   value: '5',
          //   label: '审核超时',
          // },
        ],
        // 处方类型
        category : [
          {
            value: '1',
            label: '西药/中成药',
          },
          {
            value: '2',
            label: '中药处方',
          },
        ],
        // 表头
        columns: [
          {
            title: '处方编号',
            align: 'center',
            dataIndex: 'recipeNo'
          },
          {
            title: '是否外购处方',
            align: 'center',
            dataIndex: 'negotiationFlag',
            scopedSlots: { customRender: 'negotiationFlag' },
          },
          {
            title: '处方类型',
            align: 'center',
            dataIndex: 'category',
            scopedSlots: { customRender: 'category' },
          },
          {
            title: '姓名',
            align: 'center',
            dataIndex: 'patientname'
          },
          {
            title: '性别',
            align: 'center',
            dataIndex: 'patientsex',
            scopedSlots: { customRender: 'patientsex' },
          },
          {
            title: '年龄',
            align: 'center',
            dataIndex: 'patientage'
          },
          {
            title: '科室',
            align: 'center',
            dataIndex: 'deptName'
          },
          {
            title: '医生姓名',
            align: 'center',
            dataIndex: 'drRealName'
          },
          {
            title: '医生职称',
            align: 'center',
            dataIndex: 'protitleName'
          },
          {
            title: '审核状态',
            align: 'center',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '处方上传状态',
            align: 'center',
            dataIndex: 'ybUploadStatus',
            scopedSlots: { customRender: 'ybUploadStatus' },
          },
          {
            title: '开方时间',
            align: 'center',
            dataIndex: 'createTime'
          }
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return recipePage(Object.assign(parameter, this.switchingDate())).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        refuse : false,
        refuseReason : '',
        // 审核不通过
        failedApproved : false,
        repId:'',
        visible: false,
      }
    },
    created () {
      if (this.hasPerm('recipe:edit') || this.hasPerm('recipe:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParamctstamp = this.queryParam.ctstampDate
        if (queryParamctstamp != null) {
            this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
            if (queryParamctstamp.length < 1) {
                delete this.queryParam.ctstamp
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      // 搜索框展开切换
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      // 时间框赋值
      onChangectstamp(date, dateString) {
        this.queryParam.createTime = dateString
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        recipeExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },

      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      // 调用查询接口
      getTable(){
        console.log(this.$refs.table)
        this.$refs.table.refresh();
        // this.loadData =  recipePage({}).then((res) => {
        //   console.log(res)
        //   return res.data;
        // })
      },

      // 点击查看详情
      clickDetial(record , isShow) {
        if (record.category == 1) {
          this.$refs.addFormXi.add(record, isShow)
        } else {
          this.$refs.addFormZhong.add(record, isShow)
        }
      },

     
      /**
       *调用处方上传
       */
      clickUpload(record) {
        this.loading = true;
        // return
        recipePreVer({ recipeId: record.id }).then(res => {
          const params = JSON.parse(res.msg)

          

          if (res.code == 0) {
            
            const parameter = {
              recipeId: record.id,
              rxTraceCode: params.rxTraceCode,
              hiRxno: params.hiRxno,
              mdtrtId: params.mdtrtId
            }
            recipeUpload(parameter).then(res => {
              this.loading = false;
              if (res.code == 0) {
                this.$message.success('上传成功');
                this.$refs.table.refresh()
                
              } else {
                const msg = JSON.parse(res.msg)
                this.$message.success(msg.message);
                this.$refs.table.refresh()
              }

            })
          } else { 
            this.loading = false;
            this.$message.error(params.message);
          }
          
        })
        

       
      },
    // 审核驳回
    handleReject(){
        let parameter = {};
        parameter.recipeId = this.repId;
        parameter.refuseReason = this.refuseReason;
        if(parameter.refuseReason == ''){
          this.$message.warning('请输入驳回理由，驳回理由不能为空！');
        }else{
          this.failedApproved = true;
          // parameter
          recipeCancel(parameter).then(res=>{
            this.failedApproved = false;
            console.log(res)
            if(res.code == '200'){
              this.$message.success('操作成功');
              this.refuse = false;
              this.visible = false;
           
              this.$refs.table.refresh()
            } else {
              this.$message.info(res.msg)
            }
          })
        }
        
      },
     // 点击调用审核驳回按钮调用 输入驳回理由窗口
     handleRefuse(record){
      console.log('handleRefuse评估',record)
      this.repId = record.id
      this.visible = false;
      this.refuse = true;

      },
    // 驳回输入框点击取消按钮
    handleBack(){
        this.refuse = false;
        this.visible = true;
        this.rejectValue = '';
      },
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
</style>
